import React, { type PropsWithChildren, type ReactNode } from 'react'

interface ConditionWrapComponentProps {
  condition: boolean
  wrap: (children: ReactNode) => JSX.Element
}

const ConditionWrapComponent = ({
  condition,
  wrap,
  children,
}: PropsWithChildren<ConditionWrapComponentProps>) =>
  condition ? wrap(children) : <>{children}</>

export default ConditionWrapComponent
